import { Injectable } from '@angular/core';
import { CaseFileItemService } from 'com.trumbull.phx.casefile.api-client';
import { OrderItem, OrderService } from 'com.trumbull.phx.order.api-client';
import { RecordRetrievalItemService } from 'com.trumbull.phx.recordretrievalobjective.api-client';
import { WorkService } from 'com.trumbull.phx.work.api-client';
import { catchError, combineLatest, map, Observable, of, switchMap } from 'rxjs';
import { RootObject } from '../../orders/order-details/orders.model';

export interface OrderHydrationData {
  order: OrderItem;
  orderDetails: RootObject | null;
  work: any;
  caseData: any;
  recordRetrievalData: any;
}

@Injectable({
  providedIn: 'root',
})
export class OrderHydrationService {
  constructor(
    private readonly orderService: OrderService,
    private readonly workService: WorkService,
    private readonly recordRetrievalObjectiveService: RecordRetrievalItemService,
    private readonly caseFileItemService: CaseFileItemService
  ) {}

hydrateOrderForGrid(provider: string, orderNumber: string): Observable<OrderHydrationData | null> {
return this.hydrateOrderWithCaseAndRetrieval(orderNumber, provider);
}


  hydrateOrderWithCaseAndRetrieval(
    orderNumber: string,
    workProvider?: string,
    workOffset?: number,
    workLimit?: number
  ): Observable<OrderHydrationData | null> {
    const order$ = this.orderService.getOrder('standard', orderNumber).pipe(
      catchError((error) => {
        console.error('Error fetching order:', error);
        //this.trackPlaceOrder('place-order:edit:load-failed', { source: 'order' });
        return of(null);
      })
    );

    const orderDetails$ = this.orderService.getOrderData('standard', orderNumber).pipe(
      catchError((error) => {
        console.error('Error fetching details:', error);
        //this.trackPlaceOrder('place-order:edit:load-failed', { source: 'order-data' });
        return of(null);
      })
    );

    // const workQuery = {
    //   subjectIdDescription: orderNumber,
    // };

    const work$ = this.workService
      .listWorkItems({
        subjectIdDescription: orderNumber,
      })
      .pipe(
        catchError((error) => {
          console.error('Error fetching work items:', error);
          return of(null);
        })
      );

    return combineLatest([order$, orderDetails$, work$]).pipe(
      switchMap(([order, orderDetails, work]) => {
        if (!order || !work?.workItems?.length) {
          return of(null);
        }

        const objectiveId = work.workItems?.[0]?.stories?.[0]?.objectiveId || '';

        const caseFile$ = this.caseFileItemService
          .getCaseFile(work.workItems?.[0].subjectId || '', 'standard')
          .pipe(
            catchError((error) => {
              console.error('Error fetching case items:', error);
              //this.trackPlaceOrder('place-order:edit:load-failed', { source: 'case-file' });
              return of(null);
            })
          );

        const recordRetrieval$ = this.recordRetrievalObjectiveService
          .getRecordRetrievalObjective(objectiveId || '', 'standard')
          .pipe(
            catchError((error) => {
              console.error('Error fetching recordRetrieval items:', error);
              //this.trackPlaceOrder('place-order:edit:load-failed', { source: 'record-retrieval' });
              return of(null);
            })
          );

        return combineLatest([caseFile$, recordRetrieval$]).pipe(
          map(([caseData, recordRetrievalData]) => {
            if (!caseData || !recordRetrievalData) {
              return null;
            }

            return {
              order,
              orderDetails: (orderDetails as RootObject) ?? null,
              work,
              caseData,
              recordRetrievalData,
            };
          })
        );
      })
    );
  }
}
